import React from 'react'
import { motion } from 'framer-motion'
import { MapPin, ArrowUpRight } from 'lucide-react'
export function ProjectsSection() {
  const projects = [
    {
      title: 'Kutubdia Wave Energy Pilot ',
      location: 'Kutubdia Island, Cox’s Bazar, Bangladesh',
      capacity: '150 kW (target)',
      status: 'In Development',
      description:
        'Deploy a pilot-scale wave energy converter (WEC) array to evaluate technical feasibility and generate renewable electricity for local micro-grid or community use.',
    },
    // {
    //   title: 'Island Resilience',
    //   location: 'Canary Islands, Spain',
    //   capacity: '2 MW',
    //   status: 'Planning',
    //   description:
    //     'Integrated wave energy and desalination solution for island security.',
    // },
    // {
    //   title: 'Atlantic Test Site',
    //   location: 'Cornwall, UK',
    //   capacity: '1 MW',
    //   status: 'Operational',
    //   description: 'Pilot deployment testing durability in extreme sea states.',
    // },
  ]
  const partners = [
    'OceanTech',
    'BluePower',
    'GridConnect',
    'MarineDynamics',
    'EcoWave',
  ]
  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-ocean-500 font-semibold tracking-wider uppercase text-sm mb-3">
            Projects & Partnerships
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6">
            Global Deployment
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We are actively developing projects in strategic coastal locations,
            working with local stakeholders to ensure community benefit and
            environmental stewardship.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                y: 20,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              viewport={{
                once: true,
              }}
              transition={{
                delay: index * 0.1,
              }}
              className="group bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
            >
              <div className="h-48 bg-ocean-100 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-ocean-800 to-navy-900 opacity-80 group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute bottom-4 left-4 text-white">
                  <div className="flex items-center text-sm font-medium mb-1">
                    <MapPin className="h-4 w-4 mr-1 text-ocean-500" />
                    {project.location}
                  </div>
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex justify-between items-start mb-4">
                  <h4 className="text-xl font-bold text-navy-900">
                    {project.title}
                  </h4>
                  <span className="px-2 py-1 bg-ocean-50 text-ocean-900 text-xs font-semibold rounded-full">
                    {project.status}
                  </span>
                </div>
                <p className="text-gray-600 text-sm mb-6 flex-1">
                  {project.description}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-sm font-semibold text-navy-900">
                    Capacity: {project.capacity}
                  </span>
                  <button className="text-ocean-900 hover:text-ocean-500 transition-colors">
                    <ArrowUpRight className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-gray-100 pt-16 text-center">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-8">
            Trusted by Industry Leaders
          </p>
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
            {partners.map((partner, i) => (
              <div
                key={i}
                className="text-xl font-bold text-navy-800 flex items-center"
              >
                <span className="w-8 h-8 bg-gray-300 rounded-full mr-2"></span>
                {partner}
              </div>
            ))}
          </div>
          <div className="mt-12">
            <a
              href="#contact"
              className="inline-flex items-center justify-center px-6 py-3 border border-ocean-200 text-base font-medium rounded-md text-ocean-900 bg-ocean-50 hover:bg-ocean-100 transition-colors"
            >
              Become a Partner
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
